export default {
    // 分页选项
    pageSizeOption: [10, 20, 30, 50],
    //默认显示页数
    pageSize: 20,
    //价签绑定分屏位置
    eslSplitPositionArr: [1, 2, 3, 4, 5, 6, 7, 8],
    //无心跳价签天数  澳洲
    noHeartEslOption: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],

    //遥控器步长
    REMOTE_STEP: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],

    //语言列表
    languageArr: [
        {
            value: 'zh-CN',
            label: '简体中文',
        },
        {
            value: 'en',
            label: 'English'
        },
        {
            value: 'en-US',
            label: 'English(US)'
        },
        {
            value: 'fr',
            label: 'Français'
        },
        {
            value: 'de',
            label: 'Deutsch'
        },
        {
            value: 'es',
            label: 'Español'
        },
        {
            value: 'ja',
            label: '日本語'
        }
    ],

    //执行条件判别符号
    opOption: [
        {
            label: '=',
            value: 'EQUALS'
        },
        {
            label: '!=',
            value: 'NOT_EQUALS'
        },
        {
            label: '>',
            value: 'GREATER_THAN'
        },
        {
            label: '<',
            value: 'LESS_THAN'
        },
        {
            label: 'NULL',
            value: 'IS'
        },
        {
            label: 'NOT NULL',
            value: 'IS_NOT'
        },
        {
            label: 'LIKE',
            value: 'LIKE'
        },
    ],

    //预警邮件时间
    warnDateType: {
        timeStep: '00:15',
        dateTypeOption: [
            {
                label: 'month',
                value: 'month'
            },
            {
                label: 'week',
                value: 'week'
            },
            {
                label: 'day',
                value: 'day'
            }
        ],
        month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
        week: [0, 1, 2, 3, 4, 5, 6],
        day: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    },

    // 报表配置  华润
    reportConfig: {
        dataRetainOption: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        hoursOption: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
        reportTypeOption: [
            {
                label: 'label.skuUpdateNum',
                value: 'DISTINCT_GOODS_CHANGE'
            },
            {
                label: 'label.skuUpdateTimes',
                value: 'ALL_GOODS_CHANGE'
            },
            {
                label: 'label.eslUpdateNum',
                value: 'DISTINCT_ESL_UPDATE'
            },
            {
                label: 'label.eslUpdateTimes',
                value: 'ALL_ESL_UPDATE'
            }
        ]
    },

    //角色类型
    roleTypeOption: [
        {
            label: 'NORMAL',
            value: 'NORMAL'
        },
        {
            label: 'ADMIN',
            value: 'ADMIN'
        },
        {
            label: 'PDA',
            value: 'PDA'
        }
    ],

    //电池状态选择
    batteryStatusOption: [
        {
            label: 'label.batteryStatus1', //NORMAL
            value: 1
        },
        {
            label: 'label.batteryStatus5', //PREDICTLOW
            value: 5
        },
        {
            label: 'label.batteryStatus2', //LOW
            value: 2
        },
        {
            label: 'label.batteryStatus3', //EXHAUSTION
            value: 3
        },
        {
            label: 'label.batteryStatus4', //UNKNOW
            value: 4
        },
    ],

    //设置默认页
    defaultPageOption: [
        {
            label: 1,
            value: 0
        },
        {
            label: 2,
            value: 1
        },
        {
            label: 3,
            value: 2
        },
        {
            label: 4,
            value: 3
        },
        {
            label: 5,
            value: 4
        },
        {
            label: 6,
            value: 5
        },
        {
            label: 7,
            value: 6
        },
        {
            label: 8,
            value: 7
        }
    ],

    statisticStepOption: [5, 10, 30, 60],
    lineBarChartSet: {
        line: ['goodsChangedCount', 'goodsPriceChangedCount', 'goodsNonChangedCount', 'bindGoodsCount', 'boundGoodsChangedCount'],
        bar: ['eslUpdateCount', 'eslUpdateFailureCount', 'eslUpdateSuccessCount', 'bindEslCount', 'unbindEslCount', 'pdaUpdateCount', 'cdiUpdateCount', 'webuiUpdateCount'],
    },
    lineBarColorMap: {
        goodsChangedCount: '#2391FF',    //商品变更次数
        goodsPriceChangedCount: '#7262FD',    //商品价格变更次数
        goodsNonChangedCount: '#78D3F8',    //商品数据无变化次数
        bindGoodsCount: '#025DF4',    //绑定商品
        boundGoodsChangedCount: '#5B8FF9',    //绑定商品变更次数
        eslUpdateCount: '#2498D1',    //价签更新次数
        eslUpdateFailureCount: '#f84751',    //价签更新失败次数
        eslUpdateSuccessCount: '#61DDAA',    //价签更新成功次数
        bindEslCount: '#803488',    //绑定价签次数
        unbindEslCount: '#9661BC',    //解绑价签次数
        pdaUpdateCount: '#626681',    //PDA更新价签次数
        cdiUpdateCount: '#008685',    //对接更新价签次数
        webuiUpdateCount: '#4045B2',    //页面更新价签次数 
    },
    pieColorRed: ['#9F0202', '#AD0202', '#B60909', '#C11010', '#CC1414', '#DA2E2E', '#F24949', '#FF4D4F', '#FF6666', '#FF7878', '#FFA3A3', '#FFB5B5'],
    pieColorGreen: ['#2EBF87', '#008685', '#33AD6A'],

    lineDataTime: 60000,
    otherDataTime: 300000,
    //饼图映射状态
    bindInfoRouteMap: {
        process: 'updating',
        non_heartbeat: 'failed-eslOffline',
        ap_offline: 'failed-apOffline',
        esl_error: 'failed-eslFailure',
        failed: 'failed-commError',
        data_error: 'failed-dataError',
        template_error: 'failed-templateError',
        timeout: 'failed-timeout',
        hummer_offline: 'failed-hummerOffline',
        success: 'updated',
        data_unchanged: 'updated-data_unchanged',
        cancel: 'updated-cancel',
        disallow_esl_cancel: 'failed-disallowEslCancel',
        hb_timeout_cancel: 'failed-hbTimeoutCancel',
        illegal_license: 'failed-illegal_license',
        split_screen_error: 'failed-split_screen_error',
        illegal_arguments: 'failed-illegal_arguments',
        esl_not_exist: 'failed-esl_not_exist',
        ap_not_exist: 'failed-ap_not_exist',
        user_not_exist: 'failed-userNotExist',
        internal_error: 'failed-internal_error',
        unknow: 'failed-unknow',
        nonexistent_goods: 'failed-nonexistent_goods',
    },

    //成功键值
    successMapKey: ['success', 'cancel', 'data_unchanged'],

    //价签状态
    eslStateOption: [
        {
            label: 'label.eslStateunbound',
            value: 'unbound',
            children: [
                {
                    label: 'label.eslStateactivated',
                    value: 'activated',
                },
                {
                    label: 'label.eslStateunactivated',
                    value: 'unactivated',
                },
            ]
        },
        {
            label: 'label.eslStatebound',
            value: 'bound'
        },
    ],

    //绑定状态
    bindingStateOption: [
        {
            label: 'label.eslStateupdated',
            value: 'updated',
            children: [
                {
                    label: 'label.eslStatesuccess',
                    value: 'success'
                },
                {
                    label: 'label.eslStatedataunchanged',
                    value: 'data_unchanged'
                },
                {
                    label: 'label.eslStatecancel',
                    value: 'cancel'
                },
            ]
        },
        {
            label: 'label.eslStateupdating',
            value: 'updating',
            children: [
                {
                    label: 'label.eslStateprocessing',
                    value: 'processing',
                },
                {
                    label: 'label.eslStaterepushing',
                    value: 'repushing',
                },
            ]
        },
        {
            label: 'label.eslStatefailed',
            value: 'failed',
            children: [
                {
                    label: 'label.eslStateeslOffline',
                    value: 'eslOffline',
                },
                {
                    label: 'label.eslStatedataError',
                    value: 'dataError',
                },
                {
                    label: 'label.eslStateapOffline',
                    value: 'apOffline',
                },
                {
                    label: 'label.eslStateeslFailure',
                    value: 'eslFailure',
                },
                {
                    label: 'label.eslStatecommError',
                    value: 'commError',
                },
                {
                    label: 'label.bindstatus205',
                    value: 'templateError',
                },
                {
                    label: 'label.bindstatus206',
                    value: 'timeout',
                },
                {
                    label: 'label.bindstatus207',
                    value: 'esl_not_exist',
                },
                {
                    label: 'label.bindstatus208',
                    value: 'ap_not_exist',
                },
                {
                    label: 'label.bindstatus209',
                    value: 'userNotExist',
                },
                {
                    label: 'label.bindstatus500',
                    value: 'internal_error',
                },
                {
                    label: 'label.bindstatus501',
                    value: 'illegal_license',
                },
                {
                    label: 'label.bindstatus900',
                    value: 'hummerOffline',
                },
                {
                    label: 'label.bindstatus902',
                    value: 'disallowEslCancel',
                },
                {
                    label: 'label.bindstatus903',
                    value: 'hbTimeoutCancel',
                },
                {
                    label: 'label.bindstatus904',
                    value: 'split_screen_error',
                },
                {
                    label: 'label.bindstatus101',
                    value: 'illegal_arguments',
                },
                {
                    label: 'label.bindstatus1005',
                    value: 'nonexistent_goods',
                },
                {
                    label: 'label.bindstatus9999',
                    value: 'unknow',
                },
            ]
        }
    ],

    //nfc权限选项
    nfcRight: [
        { label: 'label.nfcrights1', value: 1 },
        // { label: 'label.nfcrights2', value: 2 },
        // { label: 'label.nfcrights3', value: 3 }
    ],

    //快闪配置项
    setWorOption: [1, 2, 4, 8, 16, 32, 64],

    //价格正则
    priceRegExp: /^([1-9]\d{0,15}|0|(-\d{1,7}))(\.\d{1,4})?$/,

    //对接历史价签状态选项
    cdiEslStatusOptions: [
        {
            label: 'label.bindstatus0',
            successStatus: true,
            value: 0
        },
        {
            label: 'label.bindstatus1',
            value: 1
        },
        {
            label: 'label.bindstatus2',
            successStatus: true,
            value: 2
        },
        {
            label: 'label.bindstatus3',
            successStatus: true,
            value: 3
        },
        {
            label: 'label.bindstatus10',
            successStatus: true,
            value: 10
        },
        {
            label: 'label.bindstatus101',
            value: 101
        },
        {
            label: 'label.bindstatus200',
            value: 200
        },
        {
            label: 'label.bindstatus201',
            value: 201
        },
        {
            label: 'label.bindstatus202',
            value: 202
        },
        {
            label: 'label.bindstatus203',
            value: 203
        },
        {
            label: 'label.bindstatus204',
            value: 204
        },
        {
            label: 'label.bindstatus205',
            value: 205
        },
        {
            label: 'label.bindstatus206',
            value: 206
        },
        {
            label: 'label.bindstatus207',
            value: 207
        },
        {
            label: 'label.bindstatus208',
            value: 208
        },
        {
            label: 'label.bindstatus209',
            value: 209
        },
        {
            label: 'label.bindstatus500',
            value: 500
        },
        {
            label: 'label.bindstatus501',
            value: 501
        },
        {
            label: 'label.bindstatus900',
            value: 900
        },
        {
            label: 'label.bindstatus902',
            value: 902
        },
        {
            label: 'label.bindstatus903',
            value: 903
        },
        {
            label: 'label.bindstatus904',
            value: 904
        },
        {
            label: 'label.bindstatus1005',
            value: 1005
        },
        {
            label: 'label.bindstatus1006',
            value: 1006
        },
        {
            label: 'label.bindstatus9999',
            value: 9999
        },
    ],
    //对接历史商品状态选项
    cdigoodsStatusOptions: [
        {
            label: 'label.cdiItemStatus100',
            successStatus: true,
            value: 100
        },
        {
            label: 'label.cdiItemStatus101',
            successStatus: true,
            value: 101
        },
        {
            label: 'label.cdiItemStatus102',
            value: 102
        },
        {
            label: 'label.cdiItemStatus103',
            value: 103
        },
        {
            label: 'label.cdiItemStatus104',
            value: 104
        },
        {
            label: 'label.cdiItemStatus200',
            value: 200
        },
        {
            label: 'label.cdiItemStatus300',
            successStatus: true,
            value: 300
        }
    ],
    //闪灯颜色
    flashColorOption: [
        {
            label: 'label.flashred',
            value: 'red'
        },
        {
            label: 'label.flashgreen',
            value: 'green'
        },
        {
            label: 'label.flashblue',
            value: 'blue'
        },
        // {
        //     label: 'label.flashviolet',
        //     value: 'violet'
        // },
        // {
        //     label: 'label.flashindigo',
        //     value: 'indigo'
        // },
        // {
        //     label: 'label.flashwhite',
        //     value: 'white'
        // },
        // {
        //     label: 'label.flashyellow',
        //     value: 'yellow'
        // }
    ],
    //听帧记录-更新方式
    setWorUpdateMethodOption: [
        {
            label: 'label.mode2',
            value: 2
        },
        {
            label: 'label.mode3',
            value: 3
        },
        {
            label: 'label.mode11',
            value: 11
        }
    ],

    //异常价签-价签状态下拉
    abnormalEslStatus: [
        {
            label: 'label.bindstatus101',
            value: 'illegal_arguments'
        },
        {
            label: 'label.bindstatus200',
            value: 'non_heartbeat'
        },
        {
            label: 'label.bindstatus201',
            value: 'ap_offline'
        },
        {
            label: 'label.bindstatus202',
            value: 'esl_error'
        },
        {
            label: 'label.bindstatus203',
            value: 'failed'
        },
        {
            label: 'label.bindstatus204',
            value: 'data_error'
        },
        {
            label: 'label.bindstatus205',
            value: 'template_error'
        },
        {
            label: 'label.bindstatus206',
            value: 'timeout'
        },
        {
            label: 'label.bindstatus207',
            value: 'esl_not_exist'
        },
        {
            label: 'label.bindstatus208',
            value: 'ap_not_exist'
        },
        {
            label: 'label.bindstatus209',
            value: 'user_not_exist'
        },
        {
            label: 'label.bindstatus500',
            value: 'internal_error'
        },
        {
            label: 'label.bindstatus501',
            value: 'illegal_license'
        },
        {
            label: 'label.bindstatus900',
            value: 'hummer_offline'
        },
        {
            label: 'label.bindstatus902',
            value: 'disallow_esl_cancel'
        },
        {
            label: 'label.bindstatus903',
            value: 'hb_timeout_cancel'
        },
        {
            label: 'label.bindstatus904',
            value: 'split_screen_error'
        },
        {
            label: 'label.bindstatus1005',
            value: 'nonexistent_goods'
        },
        {
            label: 'label.bindstatus9999',
            value: 'unknow'
        },
    ],

    //翻译映射
    fieldTranslate: [],

    //旋转角度选项
    templateDirectionOption: [
        {
            label: 'label.templateDirection0',
            value: 0,
        },
        {
            label: 'label.templateDirection1',
            value: 1,
        },
        {
            label: 'label.templateDirection2',
            value: 2,
        },
        {
            label: 'label.templateDirection3',
            value: 3,
        },
    ],
    //基站硬件类型
    apHardwareOptions: [
        { label: 'label.hardware3', value: 3 },
        { label: 'label.hardware5', value: 5 },
        { label: 'label.hardware8', value: 8 }
    ],

    //基站协议类型
    apHtpVersionOptions: [
        { label: 'label.htpVersion3', value: 3 },
        { label: 'label.htpVersion5', value: 5 },
    ],
    //组网开关
    apRoamingNetlinkOptions: [
        { label: 'label.on', value: true },
        { label: 'label.off', value: false },
    ],
    //基站听帧配置
    apSetWorOption: [1, 2, 4, 8, 16, 32, 64],

    //移动场景价签类型
    moveEslTypeOptions: [
        {
            label: 'label.moveEslTypeBIND',
            value: 'BIND'
        },
        {
            label: 'label.moveEslTypePDA',
            value: 'PDA'
        }
    ],
    abnormalApReportOption: [
        {
            label: 'label.groupALL',
            value: 'all'
        },
        {
            label: 'label.lessThan30',
            value: 'lessThan'
        },
        {
            label: 'label.moreThan30',
            value: 'moreThan'
        }
    ],

    //登录验证方式
    captchaOptions: [
        {
            label: 'label.captcha1',
            value: '1'
        },
        // {
        //     label: 'label.captcha2',
        //     value: '2'
        // }
    ],

    //质保选项
    warrantyOptions: [
        {
            label: 'batteryEnd',
            sort: true,
        },
        {
            label: 'batteryFlag',
            sort: false,
            type: 'boolean',
        },
        {
            label: 'batteryPeriod',
            sort: true,
        },
        {
            label: 'maintenanceStart',
            sort: true,
        },
        {
            label: 'productEnd',
            sort: true,
        },
        {
            label: 'productPeriod',
            sort: true,
        },
        {
            label: 'productFlag',
            sort: false,
            type: 'boolean'
        },
    ],

    //基站升级任务状态
    apUpgradeStatus: [
        {
            label: 'label.upgradeTaskStatus1',
            value: 1,
        },
        {
            label: 'label.upgradeTaskStatus2',
            value: 2,
        },
        {
            label: 'label.upgradeTaskStatus3',
            value: 3,
        },
        {
            label: 'label.upgradeTaskStatus4',
            value: 4,
        },
        {
            label: 'label.upgradeTaskStatus99',
            value: 99,
        },
    ],

    apPolicyOptions: [
        {
            label: 'OPEN',
            value: 'OPEN',
        },
        {
            label: 'WPA-PSK',
            value: 'WPA-PSK',
        },
        {
            label: 'WPA2-PSK',
            value: 'WPA2-PSK',
        },
        {
            label: 'WPA3-PSK',
            value: 'WPA3-PSK',
        },
        {
            label: 'WPA-WPA2-PSK',
            value: 'WPA-WPA2-PSK',
        },
        {
            label: 'WPA2-WPA3-PSK',
            value: 'WPA2-WPA3-PSK',
        },
    ],
    //AP系统版本来源
    apVersionOptions: [
        {
            label: 'label.choseCustomer',
            value: 'CUSTOMER',
        },
        {
            label: 'label.choseStore',
            value: 'STORE',
        },
    ],

    upgradeStatusOptions: [
        {
            label: 'label.apPlanStatus0',
            value: 0,
        },
        {
            label: 'label.apPlanStatus1',
            value: 1,
        },
        {
            label: 'label.apPlanStatus2',
            value: 2,
        },
    ],
    regStatusOptions: [
        {
            label: 'label.registrationStatus0',
            value: 0,
        },
        {
            label: 'label.registrationStatus1',
            value: 1,
        },
        {
            label: 'label.registrationStatus2',
            value: 2,
        },
        {
            label: 'label.registrationStatus3',
            value: 3,
        },
    ],
    roleViewsOrder: ['ADMIN', 'NORMAL', 'PDA'],
    shelfStatusOpt: [
        {
            label: 'label.shelfStatus1',
            value: 1,
        },
        {
            label: 'label.shelfStatus2',
            value: 2,
        },
        {
            label: 'label.shelfStatus3',
            value: 3,
        },
    ],
    logStatusOpt: [
        {
            label: 'label.uplogStatus1',
            value: 1,
        },
        {
            label: 'label.uplogStatus2',
            value: 2,
        },
        {
            label: 'label.uplogStatus3',
            value: 3,
        },
    ],

    //frequency of data sync to him
    dataFrequencyTypes: ['DAILY', 'WEEKLY', 'MONTHLY'],

    //allowesl add source
    allowEslSource: [
        {
            label: 'label.addMethodtxt',
            value: 1001,
        },
        {
            label: 'label.addMethodpda',
            value: 2001,
        },
        {
            label: 'label.addMethodbind',
            value: 3001,
        },
        {
            label: 'label.addMethodinit',
            value: 4001,
        },
        {
            label: 'label.addMethodhim',
            value: 5001,
            noStore: true,
        },
        {
            label: 'label.addMethodapi',
            value: 6001,
        },
    ],

    batteryRemain: [
        {
            label: '0%',
            value: 0,
        },
        {
            label: '5%',
            value: 5,
        },
        {
            label: '10%',
            value: 10,
        },
        {
            label: '20%',
            value: 20,
        },
        {
            label: '40%',
            value: 40,
        },
        {
            label: '60%',
            value: 60,
        },
        {
            label: '90%',
            value: 90,
        },
        {
            label: '100%',
            value: 100,
            notUseEmail: true
        },
    ],

    BatteryFrezzen: [
        {
            label: `0%`,
            value: 0,
        },
        {
            label: `<= 5%`,
            value: 5,
        },
        {
            label: `<= 10%`,
            value: 10,
        },
        {
            label: '> 10%',
            value: 101,
        },
    ],

    batteryRemainSpecial: [
        {
            label: 'label.batteryRemain101',
            value: 101,
        }
    ],

    loginOperateType: [
        {
            label: 'label.logTypeLOGIN',
            value: 'LOGIN',
        },
        {
            label: 'label.logTypeLOGOUT',
            value: 'LOGOUT',
        },
    ],

    opertateSource: [
        {
            label: 'WEB',
            value: 'WEB',
        },
        {
            label: 'APP',
            value: 'APP',
        },
        {
            label: 'API',
            value: 'API',
        },
        {
            label: 'label.logSourceTP',
            value: 'TP',
            translate: true,
            notUseOperate: true,
        },
    ],

    switchPageStatusOption: [
        {
            label: 'label.taskfutureSwitchPage',
            value: 'futureSwitchPage',
            children: [
                {
                    label: 'label.pageTaskStatus0',
                    value: '0',
                },
                {
                    label: 'label.pageTaskStatus1',
                    value: '1',
                },
                {
                    label: 'label.pageTaskStatus2',
                    value: '2',
                },
                {
                    label: 'label.pageTaskStatus3',
                    value: '3',
                },
            ]
        },
        {
            label: 'label.taskswitchPage',
            value: 'switchPage',
            children: [
                {
                    label: 'label.pageTaskStatus1',
                    value: '1',
                },
                {
                    label: 'label.pageTaskStatus2',
                    value: '2',
                },
                {
                    label: 'label.pageTaskStatus3',
                    value: '3',
                },
            ]
        }
    ],
    templateStatusOptions: [
        {
            label: 'label.projectStatus0',
            value: 0,
        },
        {
            label: 'label.projectStatus1',
            value: 1,
        },
    ],
    publishPlanStatusOptions: [
        {
            label: 'label.publishStatus0',
            value: 0,
        },
        {
            label: 'label.publishStatus1',
            value: 1,
        },
        {
            label: 'label.publishStatus2',
            value: 2,
        },
        {
            label: 'label.publishStatus6',
            value: 6,
        },
    ],
    publishScopeOptions: [
        {
            label: 'label.choseCustomer',
            value: 0,
        },
        {
            label: 'label.choseStore',
            value: 1,
        }
    ],

    elIconsList: ['el-icon-setting', 'el-icon-phone-outline', 'el-icon-star-off', 'el-icon-goods', 'el-icon-warning-outline', 'el-icon-help', 'el-icon-picture-outline', 'el-icon-bell', 'el-icon-c-scale-to-original', 'el-icon-folder', 'el-icon-tickets', 'el-icon-data-board', 'el-icon-notebook-1', 'el-icon-notebook-2', 'el-icon-office-building', 'el-icon-shopping-cart-full', 'el-icon-shopping-bag-1', 'el-icon-coin', 'el-icon-guide', 'el-icon-truck'],

    userStatusOption: [
        {
            label: 'label.userStatus0',
            value: 0,
        },
        {
            label: 'label.userStatus1',
            value: 1,
        }
    ],

    checkAckTypeOption: [
        {
            label: 'label.checkAckValueType1',
            value: 1,
        },
        {
            label: 'label.checkAckValueType2',
            value: 2,
        },
        {
            label: 'label.checkAckValueType4',
            value: 4,
        },
        {
            label: 'label.checkAckValueType9999',
            value: 9999,
        },
    ],

    // emailCatategoryOption
    emailCatategoryOption: [
        {
            name: 'label.emailCategoryREALTIME',
            value: 'REALTIME',
            children: [
                {
                    label: 'label.emailConESL_WORKING_OFFLINE',
                    value: 'ESL_WORKING_OFFLINE',
                },
                {
                    label: 'label.emailConAP_OFFLINE',
                    value: 'AP_OFFLINE',
                },
                {
                    label: 'label.emailConINTEGRATION_SERVICE_EXCEPTION',
                    value: 'INTEGRATION_SERVICE_EXCEPTION',
                },
                {
                    label: 'label.emailConCDI_BATCH_TIMEOUT',
                    value: 'CDI_BATCH_TIMEOUT',
                },
                {
                    label: 'label.emailConUPDATE_FAILED_ESL',
                    value: 'UPDATE_FAILED_ESL',
                },
                {
                    label: 'label.emailConLOW_BATTERY_ESL',
                    value: 'LOW_BATTERY_ESL',
                },

            ]
        },
        {
            name: 'label.emailCategoryCYCLE',
            value: 'CYCLE',
            children: [
                {
                    label: 'label.emailConUPDATE_FAILED',
                    value: 'UPDATE_FAILED',
                },
                {
                    label: 'label.emailConLOW_BATTERY',
                    value: 'LOW_BATTERY',
                },
            ]
        }
    ],
};
